import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=77109b2c&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=77109b2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77109b2c",
  null
  
)

export default component.exports